type Props = {
  variant?: 'horizontal' | 'vertical';
  className?: string;
};

export default function Logo({ variant = 'horizontal', className = '' }: Props) {
  const src =
    variant === 'horizontal'
      ? '/logo-lunins-horizontal.png?v=5'
      : '/logo-lunins-vertical.png?v=2';
  const fallback = variant === 'horizontal' ? 'h-7 md:h-8' : 'h-14';
  const isHorizontal = variant === 'horizontal';
  return (
    <img
      src={src}
      alt="Lunins — Bem-estar"
      className={`w-auto bg-transparent object-contain object-left ${className || fallback}`}
      width={isHorizontal ? 555 : 437}
      height={isHorizontal ? 96 : 278}
      loading="eager"
      decoding="async"
    />
  );
}
